import { render, staticRenderFns } from "./OrgVehicles.vue?vue&type=template&id=714a2fee"
import script from "./OrgVehicles.vue?vue&type=script&lang=js"
export * from "./OrgVehicles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports